import "./bootstrap";
import "./components/LottieLoader";
import "./global-animations";
import Base from "./base";

// Conditionally load page scripts to reduce bundle size
if (document.getElementById('home')) {
    import("./home");
}

if (document.getElementById('projects') || document.getElementById('residential') || document.getElementById('commercial')) {
    import("./projects");
}

if (document.getElementById('bespoke')) {
    import("./bespoke");
}

if (document.getElementById('about')) {
    import("./about");
}

if (document.getElementById('news') || document.querySelector('.page-news-detail')) {
    // Handling news listing and detail if they share logic, or separate if needed.
    // Assuming news.ts handles news page.
    import("./news");
}

if (document.getElementById('contact')) {
    import("./contact");
}

if (document.querySelector('.terms-page')) {
    new Base('terms-page');
}

if (document.getElementById('project-detail')) {
    import("./project-detail");
}

